import { Alert as MuiAlert } from '@mui/material';

export default MuiAlert;
